import React from 'react';

import { PlainReferenceChip } from './PlainReferenceChip';
import type { ReferenceTriggerProps } from './referenceKinds';
import { TEXTS } from './texts';

// The guideline id claims-llm gives the cross-stage instructions; every other id is `stage.<key>`.
const GENERAL_GUIDELINE_ID = 'general';

/**
 * A cited part of the conductor's instructions: the sentence's own words, and on hover whether they come from a
 * stage's instructions (and which stage) or the general instructions. Nothing opens on click.
 */
export const GuidelineReferenceTrigger: React.FC<ReferenceTriggerProps> = ({ reference, children }) =>
  String(reference.id) === GENERAL_GUIDELINE_ID ? (
    <PlainReferenceChip asText label={children} title={TEXTS.FROM_GENERAL_INSTRUCTIONS} />
  ) : (
    <PlainReferenceChip
      asText
      label={children}
      title={TEXTS.FROM_STAGE_INSTRUCTIONS}
      secondary={reference.name ?? undefined}
    />
  );
